import { render, staticRenderFns } from "./GridComponentHNCobradores.vue?vue&type=template&id=1778698c&scoped=true"
import script from "./GridComponentHNCobradores.vue?vue&type=script&lang=js"
export * from "./GridComponentHNCobradores.vue?vue&type=script&lang=js"
import style0 from "./GridComponentHNCobradores.vue?vue&type=style&index=0&id=1778698c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1778698c",
  null
  
)

export default component.exports